import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import CreateIcon from "@mui/icons-material/Create";

//Srcs
import "../../../Style/actionStyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import StudentForm from "./StudentForm";
import DeleteForm from "../../Include/DeleteForm";

import { DELETE_STUDENT } from "../../../Schema/Student";

export default function StudentAction({ editData, setRefetch, userLogin }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //======================== delete =========================
  const [deleteStudent] = useMutation(DELETE_STUDENT, {
    onCompleted: ({ deleteStudent }) => {
      // console.log("deleteStudent::", deleteStudent);
      setLoading(false);
      if (deleteStudent?.is_success === true) {
        setAlert(true, "success", deleteStudent?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteStudent?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteStudent({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("tooltip-update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <CreateIcon className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title={t("tooltip-delete")} placement="top" sx={{display: userLogin?.role === "Admin" ? "block" : "none"}}>
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <StudentForm
        dialogTitle="Update"
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />
      <DeleteForm
        open={openDel}
        handleClose={handleCloseDel}
        title="dialog_title_delete_student"
        handleDelete={handleDelete}
      />
    </div>
  );
}
